import styles from './style.postcss';
import React, { PureComponent } from 'react';
import is from 'is_js';
import PropTypes from 'prop-types';
import { connect } from 'omni-common-ui';
import { actions as notesActions } from 'containers/Student/Note';
import classnames from 'classnames';
import { accessors as ProgressTests } from 'data/ProgressTests';

export const Type = {
  attendance: notesActions.STUDENT_NOTE_CATEGORY_ATTENDANCE,
  progressTest: notesActions.STUDENT_NOTE_CATEGORY_PROGRESS_TEST,
};

export class QuickSummary extends PureComponent {
  _renderUnitInfo() {
    if (is.existy(this.props.currentUnit)) {
      return `, ${this.props.currentUnit.name}`;
    }
    return '';
  }

  _renderAttendance() {
    if (is.existy(this.props.currentSession)) {
      const { currentSession: { sessionType, index: sessionIndex } } = this.props;
      return <span className={classnames(styles.QuickSummary, this.props.className)}>
        {`${sessionIndex}/${this.props.sessionNumber}`}
        <span> (<span className={styles.QuickSummary_unit}>{sessionType}</span>)</span>
        {this._renderUnitInfo()}
      </span>;
    }
    return null;
  }

  _renderProgressTest() {
    if (is.existy(this.props.currentProgressTest)) {
      return <span className={styles.QuickSummary}>
        {ProgressTests.getPTName(
          this.props.currentProgressTest.name, this.props.isSSV3Group)}
      </span>;
    }
    return null;
  }

  render() {
    switch (this.props.type) {
      case Type.attendance: return this._renderAttendance();
      case Type.progressTest: return this._renderProgressTest();
      default: return null;
    }
  }
}

QuickSummary.propTypes = {
  className: PropTypes.string,
  entityId: PropTypes.string,
  type: PropTypes.string,
  currentSession: PropTypes.object,
  currentUnit: PropTypes.object,
  sessionNumber: PropTypes.number,
  currentProgressTest: PropTypes.object,
  isSSV3Group: PropTypes.bool,
};

QuickSummary.Type = Type;

export function mapStateToProps(state, ownProps) {
  if (ownProps.type === Type.attendance) {
    const { entityId } = ownProps;
    const sessions = state.get('rootReducer').get('sessionPlans');
    const currentSession = sessions.get(entityId);
    return {
      currentSession,
      sessionNumber: ownProps.sessionCount,
    };
  }
  if (ownProps.type === Type.progressTest) {
    const progressTestPlan = state.get('rootReducer').get('progressTestsPlan');
    let currentProgressTest;
    if (is.existy(progressTestPlan)) {
      progressTestPlan.forEach((groupPlan) => {
        if (groupPlan && groupPlan.data) {
          currentProgressTest = groupPlan.data.find((plan) => plan.id === ownProps.entityId);
          if (currentProgressTest) return false;
        }
      });
    }

    return {
      isSSV3Group: ownProps.isSSV3Group,
      currentProgressTest,
    };
  }
}

export default connect(mapStateToProps, null)(QuickSummary);



// WEBPACK FOOTER //
// ./components/QuickSummary/index.jsx